import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Banner from './components/Banner';
import PostersGrid from './components/PostersGrid';
import PosterPage from './components/PosterPage';
import DataComponentPage from './components/DataComponentPage';
import Footer from './components/Footer';
import { posters } from './data/posters';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Banner />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<PostersGrid posters={posters} />} />
            <Route path="/poster/:id" element={<PosterPage />} />
            <Route path="/poster/:id/:data_id" element={<DataComponentPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
